
$(document).ready(function () {
    var slickSettings = {
        arrows: false,  // disable default arrows, we will use our own.
        dots: true,    // Enable pagination dots
        fade: true,    // Enable fade transition
        speed: 600,
        touchThreshold: 10,
        autoplay: false, // true,
        autoplaySpeed: 6000
    };

    var heroCarousel = $('.hero-carousel__slides').slick(slickSettings);

    $('.hero-carousel').on('full-width-resize', function (e) {
        $('.hero-carousel__slides').slick("unslick").slick(slickSettings);
    });

    $('.hero-carousel__pagination-previous').on('click',
        function() {
            heroCarousel.slick('slickPrev');
        });
    $('.hero-carousel__pagination-next').on('click',
        function () {
            heroCarousel.slick('slickNext');
        });
});
